import { api } from "./api";


export const googleLoginApi = (params) => {
    return api.post(`/hub/auth/google-login`, JSON.stringify(params));
};

export const googleAuthApi = (params) => {
    return api.post(`/hub/auth/google-auth`, JSON.stringify(params));
};

export const emailLoginApi = (params) => {
    return api.post(`/hub/auth/email-login`, JSON.stringify(params));
};

export const emailPasswordLoginApi = (params) => {
    return api.post(`/hub/auth/email-password-login`, JSON.stringify(params));
};

export const emailSignUpApi = (params) => {
    return api.post(`/hub/auth/email-sign-up`, JSON.stringify(params));
};

export const forgotPasswordApi = (params) => {
    return api.post(`/hub/auth/forgot-password`, JSON.stringify(params));
};

export const resetPasswordApi = (params) => {
    return api.post(`/hub/auth/reset-password`, JSON.stringify(params));
};

export const verifyTokenApi = (params) => {
    return api.post(`/hub/auth/verify-token`, JSON.stringify(params));
};